// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__QsGSM","Responsive":"Sidebar_Responsive__uhNMK","usersChat":"Sidebar_usersChat__h-uKj"};